import React, { forwardRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/landing';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  tone?: 'light' | 'dark';
  className?: string;
};
export const CtaButton = forwardRef<HTMLAnchorElement, CtaButtonProps>(function CtaButton({
  label,
  sublabel,
  tone = 'light',
  className = ''
}, ref) {
  return <div className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-27" data-mp="qk1zz2w5dedf">
      <a ref={ref} href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta-500 px-5 py-5 text-[1.05rem] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0f5f2c] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-600 active:translate-y-[4px] active:shadow-[0_2px_0_0_#0f5f2c] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-400/60 sm:py-6 sm:text-xl" data-id="element-28" data-mp="llh1b7wjn2r3">
        <span className="text-balance" data-id="element-29" data-mp="35xnziuctg2jd">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="35yz6t45gzsf8" />
      </a>
      {sublabel && <p className={`mt-4 text-sm leading-relaxed ${tone === 'dark' ? 'text-white/75' : 'text-navy-900/70'}`} data-id="element-31" data-mp="3ezxa1k833vwr">
          {sublabel}
        </p>}
    </div>;
});